var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-chip",class:{
    successStatus: _vm.status === 'success',
    activeStatus: _vm.status === 'active',
    errorStatus: _vm.status === 'error',
    fixedWidth: _vm.fixedWidth,
    rightPadding: _vm.rightPadding,
  }},[(_vm.loading)?_c('v-icon',{staticClass:"loading-spinner mr-2",attrs:{"small":"","color":_vm.loadingColor}},[_vm._v("mdi-cached")]):_vm._e(),_vm._v(_vm._s(_vm.text)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }